import { render, staticRenderFns } from "./StudentClassFilter.vue?vue&type=template&id=bcb89a48&"
import script from "./StudentClassFilter.vue?vue&type=script&lang=js&"
export * from "./StudentClassFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports